import React from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import canOrder from 'utils/canOrder'
import { Icon } from './Icon'
import { t } from '@billes/translator-client'

const Basket = ({ currentFile, onBeforeAddToBasket, group }) => {
  if (!canOrder(group)) {
    return null
  }
  return (
    <div
      onClick={e => onBeforeAddToBasket()}
      style={{ cursor: 'pointer' }}
      title={t('bms.media.titles.addSelectedFilesToBasket')}
    >
      <Icon hasFiles={currentFile} />
    </div>
  )
}

export default connect(
  {
    currentFile: state`media.currentFile`,
    onBeforeAddToBasket: signal`basket.onBeforeAddToBasket`,
    group: state`app.user.group`
  },
  Basket
)



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/Basket/basket.js